import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { TensionService } from 'src/shared/services/tension.service';
import { Tension } from './tension-assets/tension-model';
import { jsPDF } from 'jspdf';
import Swal from 'sweetalert2';
import { ErrorLibService } from 'src/shared/services/error-lib.service';
import { Unsubscriber } from 'src/shared/components/unsubscriber/unsubscriber.component';

// Imports Standalone
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { PageHeaderComponent } from 'src/shared/components/page-header/page-header.component';
import { TableHeaderComponent } from 'src/shared/helper-components/table-header/table-header.component';
import { RegisterFormComponent } from '../register-form/register-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-tension',
  templateUrl: './tension.component.html',
  styleUrls: ['./tension.component.less'],
  imports: [
    CommonModule,
    PageHeaderComponent,
    TableHeaderComponent,
    RegisterFormComponent,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    ButtonModule,
    TranslateModule
  ]
})
export class TensionComponent extends Unsubscriber implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    public errorLibService: ErrorLibService,
    private tensionService: TensionService,
  ) {
    super();
  }

  ngOnInit(): void {
    /** Verifica se uma empresa foi selecionada pelo usuário **/
    this.companySelected = localStorage.getItem('lastCompanySelected')
      ? localStorage.getItem('lastCompanySelected')
      : null;
  }

  // Variaveis responáveis por abrir e fechar as boxes
  public register: boolean = false;
  public filter: boolean = false;

  // Variaveis responsáveis pelos loadings da tela
  public filterLoading: boolean = false;
  public registerLoading: boolean = false;
  public fileLoading: boolean = false;

  //Variavel responsável por armazenas os dados da tabela
  public totalNumber: number = 0;
  public ELEMENT_DATA: Tension[] = [];

  /** Variáveis utilizadas para geração e manipulação dos arquivos PDF e CSV **/
  public FILE_DATA: Tension[] = [];
  public isReady = false;

  // Variável que guarda o número de relatórios retornados do backend.
  public resultsLength = this.ELEMENT_DATA.length;

  // Para receber o ID da company selecionada.
  public companySelected: string | null;

  // Controlador para apresentação da label edição de tensão.
  public editorController: boolean = false;


  // Renderiza os comandos da lista ELEMENT_DATA para a tabela
  public dataSource = new MatTableDataSource<Tension>(this.ELEMENT_DATA);

  /**
   * Função que configura o paginator.
   */
  public setDataSourceAttributes() {
    this.totalNumber = this.ELEMENT_DATA.length;
    this.dataSource.data = this.ELEMENT_DATA;
  }

  // Armazena os dados do formulário de filtro de tensão, o valor é setado automáticamente pelo HTML
  public registerTensionForm: FormGroup = this.formBuilder.group({
    high_tension: [null, Validators.required],
    low_tension: [null, Validators.required],
  });

  // Formulário com o conteúdo a ser editado na API.
  public updateForm: FormGroup = this.formBuilder.group({
    high_tension: [null, Validators.required],
    low_tension: [null, Validators.required],
  });

  // Função responsável por mudar o estado da box de filtro e fechar a de registro
  public filterBox(): void {
    this.register = false;
    this.filter = !this.filter;
  }

  // Função responsável por mudar o estado da box de registro e fechar a de filtro
  public registerBox(): void {
    this.filter = false;
    this.register = !this.register;
  }

  /**
   * Função responsavel por filtrar Tensão
   */
  public filterTension() {
    this.filterLoading = true;
    this.subscriptions = this.tensionService
      .filterTension(this.companySelected)
      .valueChanges.subscribe({
        next: (response: any) => {

          this.ELEMENT_DATA = [];

          // Adiciona cada tensão retornada pela requisição na lista
          this.ELEMENT_DATA.push(
            new Tension(
              response?.data?.getTension?.tension?.highTension,
              response?.data?.getTension?.tension?.lowTension
            )
          );

          /** Atualiza a tabela com os novos dados **/
          this.setDataSourceAttributes();
          //this.isReady = false;

          if (this.ELEMENT_DATA.length === 0) {

            // Desativa o loading
            this.filterLoading = false;

            /** Retorna alerta ao usuário **/
            Swal.fire({
              title: 'Sua busca não retornou resultados',
              text: 'Nenhum resultado para este filtro',
              icon: 'warning',
              confirmButtonText: 'Ok',
            });
          }

          //Desativa o loading
          this.filterLoading = false;
        },
        error: (error: any) => {
          this.errorLibService.errorAlert(error);

          //Desativa o loading
          this.filterLoading = false;
        },
      });
  }

  /**
   * Função responsavel por criar Tensão
   */
  public registerTension() {
    if (this.registerTensionForm.valid) {
      this.registerLoading = true;

      this.subscriptions = this.tensionService
        .registerTension(
          this.companySelected,
          parseFloat(this.registerTensionForm.get('high_tension')?.value),
          parseFloat(this.registerTensionForm.get('low_tension')?.value)
        )
        .subscribe({
          next: () => {
            this.filterTension();

            Swal.fire({
              title: 'Tensão criada',
              text: 'Tensão criada com sucesso',
              icon: 'success',
              confirmButtonText: 'Ok',
            });

            this.registerLoading = false;
            this.setDataSourceAttributes();
          },
          error: (error: any) => {
            this.errorLibService.errorAlert(error);
            this.registerLoading = false;
          },
        });
    } else {
      Swal.fire({
        title: 'Formulário Incompleto',
        text: 'Preencha todos os campos',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });

      this.registerLoading = false;
    }
  }

  public updateGetter(high_tension: string | null, low_tension: string | null) {
    this.updateForm.setValue({
      high_tension,
      low_tension,
    });
    this.editorController = true;
  }

  // Realiza a alteração dos dados da tensão.
  public updateTension() {
    if (this.updateForm.valid) {
      this.subscriptions = this.tensionService
        .updateTension(
          this.companySelected,
          this.updateForm.get('high_tension')?.value,
          this.updateForm.get('low_tension')?.value
        )
        .subscribe({
          next: (response: any) => {
            /** Validar se a resposta está carregando ou se não há dados **/
            if (response.loading || !response.data) {
              return;
            }

            Swal.fire({
              title: 'Tensão atualizada',
              text: 'Tensão atualizada com sucesso',
              icon: 'success',
              confirmButtonText: 'Ok',
            });
            this.ELEMENT_DATA = [];
            this.ELEMENT_DATA.push(
              new Tension(
                response?.data?.updateTension?.tension?.highTension,
                response?.data?.updateTension?.tension?.lowTension
              )
            );
            this.setDataSourceAttributes();
            this.editorController = false;
          },
          error: (error: any) => {
            console.log('updateTension', error);
            this.errorLibService.errorAlert(error);
          },
        });
    } else {
      Swal.fire({
        text: 'Confirme os dados antes de atualizar',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    }
    // Fecha a tela lateral.
    this.editorController = false;
  }

  // Fecha a barra lateral quando clicado no botão.
  public closeEditionSideBar() {
    // Fecha a tela lateral.
    this.editorController = false;
  }

  // Funções para deletar Tensão
  public deleteConfirm(): void {
    Swal.fire({
      title: 'Deseja mesmo deletar este registro de tensão?',
      icon: 'warning',
      showDenyButton: true,
      confirmButtonText: 'Confirmar',
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteTension();
      }
    });
  }

  public deleteTension() {
    this.subscriptions = this.tensionService
      .deleteTension(this.companySelected)
      .subscribe({
        next: (response: any) => {
          Swal.fire({
            title: 'Tensão deletada',
            text: 'Tensão deletada com sucesso',
            icon: 'success',
            confirmButtonText: 'Ok',
          });
          this.ELEMENT_DATA = [];
          this.setDataSourceAttributes();
          this.editorController = false;
        },
        error: (error: any) => {
          console.log('deleteTension', error);
          this.errorLibService.errorAlert(error);
        },
      });
  }

  // ---------------------------------------------------------------------
  // Código destinado à funções de download de CSV e PDF da página.

  public generateFileData(fileType: string) {
    this.fileLoading = true;
    /** Verifica se a lista está pronta **/
    if (this.isReady == false) {
      this.subscriptions = this.tensionService
        .filterTension(this.companySelected)
        .valueChanges.subscribe({
          next: (response: any) => {
            /** Validar se a resposta está carregando ou se não há dados **/
            if (response.loading || !response.data) {
              return;
            }

            this.FILE_DATA.push(
              new Tension(
                response?.data?.getTension?.tension?.highTension,
                response?.data?.getTension?.tension?.lowTension
              )
            );

            this.isReady = true;
            this.generateFileData(fileType);
          },
          error: (error: any) => {
            this.errorLibService.errorAlert(error);
          },
        });
    } else {
      /** Caso a lista esteja pronta gera o arquivo escolhido pelo usuário **/
      this.fileLoading = false;
      if (fileType === 'PDF') {
        this.downloadPDF();
      } else {
        this.downloadCSV();
      }
    }
  }

  // Converte o conteúdo em CSV. Privado porque só usa aqui nessa classe.
  private convertToCSV(arr: any) {
    // Transforma o objeto numa lista onde o primeiro elemento é o cabeçalho com o nome das colunas.
    const content = [Object.keys(arr[0])].concat(arr);

    // Retorna o conteúdo mapeado como string linha a linha adicionando quebra de linha em cada um.
    return content
      .map((item) => {
        return Object.values(item).toString().replace(',', ';');
      })
      .join('\n');
  }

  // Função que realiza o download do CSV.
  public downloadCSV() {
    let content: any = [];

    // Adicoina cada elemento como um objeto na lista de conteúdo.
    this.FILE_DATA.forEach((tension) => {
      content.push({
        Alta: tension.highTension,
        Baixa: tension.lowTension,
      });
    });

    // Adiciona o conteúdo convertido dentro de uma nova variável.
    let data = this.convertToCSV(content);
    // Transforma o conteúdo para o formato blob para geração do arquivo.
    let file = new Blob([data], { type: 'text/csv' });
    // Cria um endereçamento para o arquivo.
    let url = window.URL.createObjectURL(file);
    // Cria um elemento para a linkagem do arquivo.
    let link = document.createElement('a');
    // Adiciona a url no elemento de linkagem.
    link.href = url;
    // Nomeia o arquivo que será feito o download.
    link.download = `${new Date().toLocaleDateString()}-${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}-tension.csv`;
    // Adiciona o link no documento.
    document.body.appendChild(link);
    // Atica o evento de click para realizar o download.
    link.click();
    // Remove o link do documento.
    document.body.removeChild(link);
    // Remove o endereço do download.
    window.URL.revokeObjectURL(url);

    this.FILE_DATA = [];
    this.isReady = false;
  }

  // Função que realiza o download do CSV.
  public downloadPDF() {
    // Define o cabeçalho do documento.
    const header = ['Alta Tensão', 'Baixa Tensão'];
    // Lista que irá conter o conteúdo retornado pela API.
    let content: any = [];
    // Inserção do conteúdo na lista.
    this.FILE_DATA.forEach((tension) => {
      content.push([tension.highTension, tension.lowTension]);
    });
    // Define o formato do documento.
    let file: any = new jsPDF('l', 'mm', 'a4');
    // Cria o PDF.
    file.autoTable({
      theme: 'grid',
      margin: { top: 20 },
      head: [header],
      body: content,
    });
    // Gera o download do documento.
    file.save(
      `${new Date().toLocaleDateString()}-${new Date().getHours()}:${new Date().getMinutes()}-tension.pdf`
    );

    this.FILE_DATA = [];
    this.isReady = false;
  }
}
